import { fieldsOf } from '../entities';
import {
  getField,
  isLayered,
  isGroup,
  valueSource,
  type DrawingDocument,
  type NodeId,
  type SceneNode,
} from '../model';
import type { ResolvedScene } from '../scene';
import type { NodeSummary, TreeEntry } from './types';

/** Read models over a document: plain JSON a UI can use as is. */
export function summarize(scene: ResolvedScene, node: SceneNode): NodeSummary {
  const fields: Record<string, string> = {};
  for (const field of fieldsOf(node)) {
    const current = getField(node, field.path);
    if (current !== undefined) fields[field.path] = valueSource(current);
  }
  const error = scene.errors[node.id];
  return {
    id: node.id,
    type: node.type,
    name: node.name,
    parentId: node.parentId,
    visible: node.visible,
    locked: node.locked,
    ...(isLayered(node) ? { layerId: node.layerId } : {}),
    fields,
    ...(error === undefined ? {} : { error }),
  };
}

export function tree(
  doc: DrawingDocument,
  scene: ResolvedScene,
  parentId: NodeId | null = null,
): TreeEntry[] {
  const parent = parentId === null ? null : doc.nodes[parentId];
  const childIds =
    parentId === null ? doc.rootIds : parent && isGroup(parent) ? parent.childIds : [];
  return childIds
    .map((id) => doc.nodes[id])
    .filter((node): node is SceneNode => node !== undefined)
    .map((node) => ({ ...summarize(scene, node), children: tree(doc, scene, node.id) }));
}
